import styled from 'styled-components';

export const WithPointerEvents = styled.div`
  pointer-events: auto;
`;
